import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ReactPaginate from 'react-paginate';
import Postman from '../utils/service';
import { withRouter, Link } from 'react-router-dom'
import { Helmet } from 'react-helmet';
import EnhancedTableHead from './tableHead';
import {
  BrowserView,
  MobileView,
} from "react-device-detect";
import { cutString, encodeforspace, amountFormatter, showEzoicAds } from '../utils/helper'
import { isEmpty } from '../common/utils'
import { connect } from "react-redux"
import { SET_FILTER_RESULT_COUNT } from '../actions/actiontypes'
import LazyLoad from 'react-lazyload';
import ReactTooltip from "react-tooltip";
import AdSense from 'react-adsense';
import Cookies from 'js-cookie';

const rows = [
  { id: 'ranking', numeric: true, disablePadding: false, label: 'Rank' },
  { id: 'company_name', numeric: false, disablePadding: false, label: 'Company' },
  { id: 'city', numeric: true, disablePadding: false, label: 'City' },
  { id: 'country', numeric: true, disablePadding: false, label: 'Country' },
  { id: 'total_funding_float', numeric: true, disablePadding: false, label: 'Funding' },
  { id: 'Industry', numeric: true, disablePadding: false, label: 'Industry' },
  { id: 'current_employees', numeric: true, disablePadding: false, label: 'Employees' },
  { id: 'estimated_revenues', numeric: true, disablePadding: false, label: 'Revenue' },
  { id: 'employee_growth', numeric: true, disablePadding: false, label: 'Growth %' },
  { id: 'Name', numeric: true, disablePadding: false, label: 'Person Name' },
  { id: 'Title', numeric: true, disablePadding: false, label: 'Title' },
  { id: 'Email/Phone', numeric: true, disablePadding: false, label: 'Phone/Email' },


];

const styles = theme => ({
  root: {
    width: '100%',
    //height: 645,
    // marginTop: theme.spacing.unit * 1,
    // marginBottom: 20,
    overflowX: 'auto'
  },
  table: {
    minWidth: 820,
    height: 500,
  },
  tableWrapper: {
    overflowX: 'auto',
  }
  
});



class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    const rowsPerPage = 50
    this.state = {
      order:  props.navUrl == '/search/' ? 'desc' : 'asc',
      orderBy: props.navUrl == '/search/' ? 'employee_growth' : 'ranking',
      offset: 0,
      selected: [],
      data: [],
      page: 0,
      rowsPerPage: rowsPerPage,
      tableData: props.tableData.data || [],
      pageCount: props.tableData.totalCount / rowsPerPage,
      navUrl: props.navUrl || '/home/',
      navBaseUrl: props.navBaseUrl || '/',
      fullReload: props.fullReload || false,
      state: null,
      country: null,
      _page: 0,
      showAd: false,
      filterKey: 0,
      isLoading: false,
      isLoggedIn: Cookies.get('token') || Cookies.get('accessToken') ? true : false,
      showAlertRevealPhone: false,
      empContacts: []
    };
    this.flag = false;
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy }, () => this.getData());

  };
  handleClick = (event, company, id) => {

    event.stopPropagation()
    this.props.history.push(`/company/${encodeforspace(company)}`);
  }
  handleChangePage = (event, page) => {

  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  getData = () => {
    var n = Math.random(); 
    // this.setState({filterKey : n, isLoading: true})
    let params = new URLSearchParams(this.props.location.search);
    let query = params.get('query');
    const { order, orderBy, offset, rowsPerPage } = this.state
    const filter = this.props.filter || {}
    if (query) {
      filter.query = query
    } else {
      delete filter.query
    }
    Postman.getCompanies(order, orderBy, offset, rowsPerPage, filter)
      .then(res => {
          this.props.setFilterCount(res.data.totalCount)
          this.setState({ isLoading: false, tableData: res.data.data, pageCount: res.data.totalCount / rowsPerPage })
          
          showEzoicAds([118, 119, 120]);
          this.setState({ showAd: false })
          setTimeout(() => {
            this.setState({ showAd: true })
          }, 1000)

        

      })
  }

  componentDidMount() {
    this.setState({ showAd: true })
  }

  componentWillReceiveProps(nextProps) {
    const page = nextProps.page;
    const offset = (page - 1) * this.state.rowsPerPage || 0;
    this.setState({ offset }, () => this.getData());
    this.setState({ showAd: false })
      setTimeout(() => {
        this.setState({ showAd: true })
      }, 1000)
  }

  getPhoneEmail = (id) => {
    if(!this.state.isLoggedIn) 
      return this.props.history.push('/join');
    Postman.getEmployeePhoneEmail(id)
      .then(res => {
        if (res.data.emp && res.data.emp.id) {
          this.setState({ empContacts: { ...this.state.empContacts, [id]: res.data.emp } })
        } else {
          this.setState({ showAlertRevealPhone: true })
        }
      })
  }

  handlePageClick = ({ selected }) => {
    const { filter } = this.props

    if (!isNaN(selected) && (isEmpty(filter) || filter.name)) {
      if (!this.state.fullReload) {
        if (selected > 0) this.props.history.push(`${this.state.navUrl}${selected + 1}`)
        if (selected == 0) this.props.history.push(`${this.state.navBaseUrl}`)
      } else {
        let newUrl = window.location.href;
        if (selected > 0) newUrl = `${window.location.origin}${this.state.navUrl}${selected + 1}`
        if (selected == 0) newUrl = `${window.location.origin}${this.state.navBaseUrl}`
        if (newUrl !== window.location.href) {
          window.location.href = newUrl;
        }
      }

    }

    const offset = selected * this.state.rowsPerPage || 0

    this.setState({ offset }, () => this.getData())
  }
  render() {
    const { classes } = this.props;
    const { data, order, orderBy, selected, rowsPerPage, tableData, pageCount } = this.state;

    const page = this.props.match.params.page || 1
    return (
      <div>
        <Helmet>
          <link rel="canonical" href="https://growjo.com" />
        </Helmet>
        <Paper className={classes.root} style={{ boxShadow: 'none' }}>
          <div style={{ overflowX: 'auto' }}>
            <br/>
            <Table  aria-labelledby="tableTitle" style={{ minWidth: 820, height: 500, tableLayout: 'fixed', whiteSpace: 'nowrap', filter: (this.state.isLoading ? 'blur(3px)' : '')}}>
              <colgroup>
                <col style={{ width: "3%" }} />
                <col style={{ width: "11%" }} />
                <col style={{ width: "8%" }} />
                <col style={{ width: "5%" }} />
                <col style={{ width: "5%" }} />
                <col style={{ width: "7%" }} />
                <col style={{ width: "6%" }} />
                <col style={{ width: "6%" }} />
                <col style={{ width: "5%" }} />
                <col style={{ width: "9%" }} />
                <col style={{ width: "7%" }} />
                <col style={{ width: "12%" }} />
              </colgroup>
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
                rowCount={data.length}
                rows={rows}
                type='home'
              />
              <tbody >
                {
                  tableData.map((n, index) => {
                    let AD = ''
                    if (index == 15) {
                      AD = (
                        <AdSense.Google
                        client='ca-pub-1304487994033637'
                        slot='1063249085'
                        style={{ display: "block" }}
                        responsive='true'
                        format="auto"
                      />
                        // <div id="ezoic-pub-ad-placeholder-118"> </div>
                      )
                    } 
                    // else if (index == 30) {
                    //   AD = (
                    //     <div id="ezoic-pub-ad-placeholder-119"> </div>
                    //   )
                    // } else if (index == 45) {
                    //   AD = (
                    //     <div id="ezoic-pub-ad-placeholder-120"> </div>
                    //   )
                    // }
                    const isSelected = this.isSelected(n.id);
                    let cityLink = n.metro_city ? <Link className='custom-anchor' key={n.id} to={`/city/${encodeforspace(n.metro_city)}`}>{cutString(n.metro_city,10)}</Link> : cutString(n.city, 10);
                    if (n.country === 'United States') n.country = 'USA';

                    let empPhoneEmail = null
                      if (n.employeeData) {
                        let empId = n.employeeData.id
                        empPhoneEmail = (<button style={{ borderRadius: "7px" }} className='btn btn-primary' onClick={() => this.getPhoneEmail(empId)}>Reveal Email/Phone</button>)

                        let empEmail = n.employeeData.email;
                        let empPhone = n.employeeData.phone;

                        if (this.state.empContacts[empId]) {
                          empEmail = this.state.empContacts[empId].email;
                          empPhone = this.state.empContacts[empId].phone;
                        }

                        if (empEmail || empEmail) {
                          empPhoneEmail = (
                            <React.Fragment>
                              <a href={`mailto:${empEmail}`}>{empEmail}</a>
                              <i style={{ paddingLeft: '5px', cursor: 'pointer' }} className="fa fa-copy" onClick={() => { navigator.clipboard.writeText(empEmail) }}></i>
                              <br />
                              {empPhone}
                            </React.Fragment>)
                        }
                      }

                    return (
                      <React.Fragment>
                        {this.state.showAd && AD != '' && 
                        <TableRow key={"ad-row_" + index}>
                            <TableCell
                              className="text-center"
                              colSpan={9}
                            >
                                {AD}
                            </TableCell>
                          </TableRow>}
                        <TableRow
                          hover
                          role="checkbox"
                          aria-checked={isSelected}
                          tabIndex={-1}
                          key={n.id}
                          selected={isSelected}
                        >
                          <td className='text-center' style={{ backgroundColor: 'white', padding: 0 }}>
                            <div className="ranking-wrapper">
                              {n.ranking ? n.ranking : 'N/A'}
                            </div>
                          </td>
                          <td className="text-start">
                            <LazyLoad>
                              <a href={`//${n.url}`} target="_blank" onClick={(e) => { e.stopPropagation() }} style={{ marginRight: 5, fontSize: 15, color: '#13135c', textDecoration: "none" }}>
                                <img src={`https://www.google.com/s2/favicons?domain=${n.url}`} style={{ marginRight: 5, width: 18, height: 18 }} />
                              </a>
                            </LazyLoad>
                            <Link key={n.id} to={`/company/${encodeforspace(n.company_name)}`} style={{ marginRight: 5, fontSize: 15, textDecoration: 'none' }}>{cutString(n.company_name, 15)}</Link>

                          </td>
                          <td className="text-start">
                            {cityLink}
                          </td>
                          <td className="text-start">{n.country}</td>
                          <td className="text-start">{n.total_funding}</td>
                          <td className="text-start">
                            <Link className='custom-anchor' key={n.id} to={`/industry/${encodeURIComponent(n.Industry)}`}>{cutString(n.Industry, 10)}</Link>
                          </td>
                          <td className="text-start" >
                            {n.current_employees}
                          </td>
                          <td className="text-start">${amountFormatter(n.estimated_revenues, 1)}</td>
                          <td className="text-start">{Math.round(n.employee_growth)}%</td>
                          <td className="text-start">
                          {n.employeeData &&
                                <Link key={n.employeeData.id} to={`/employee/` + encodeforspace(n.employeeData.first_name + '-' + n.employeeData.last_name) + '-' + n.employeeData.id} style={{ marginRight: 5, fontSize: 15, textDecoration: 'none' }}>
                                  {cutString(n.employeeData.first_name + ' ' + n.employeeData.last_name, 15)}
                                </Link>
                              }

                              {!n.employeeData && '-'}
                          </td>
                          <td className="text-start">{n.employeeData ? cutString(n.employeeData.title, 10) : '-'}</td>
                          <td className="text-start"> 
                          {n.employeeData && empPhoneEmail}
                              {!n.employeeData && '-'}</td>

                          
                        </TableRow>
                      </React.Fragment>
                    );
                  })}

              </tbody>
            </Table>
          </div>
        </Paper>
        <div className='mt-4 d-flex justify-content-center align-items-center '>
          <BrowserView>
            <ReactPaginate
              previousLabel={<i className="fa fa-arrow-left "></i>}
              nextLabel={<i className="fa fa-arrow-right "></i>}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={this.state.pageCount}
              marginPagesDisplayed={3}
              pageRangeDisplayed={10}
              onPageChange={this.handlePageClick}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
              initialPage={this.props.match.params.page - 1}
              hrefBuilder={(page) => page == 1 ? `${this.state.navBaseUrl}` : `${this.state.navUrl}${page}`}
            />
          </BrowserView>
          <MobileView>
            <ReactPaginate
              previousLabel={<i className="fa fa-arrow-left "></i>}
              nextLabel={<i className="fa fa-arrow-right "></i>}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={this.state.pageCount}
              marginPagesDisplayed={1}
              pageRangeDisplayed={1}
              onPageChange={this.handlePageClick}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
              initialPage={this.props.match.params.page - 1}
            />
          </MobileView>
        </div>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  filter: state.filter.data
})
const mapDispatchToProps = dispatch => ({
  setFilterCount: count => dispatch({ type: SET_FILTER_RESULT_COUNT, payload: count }),
})
export default withStyles(styles)(withRouter(connect(mapStateToProps, mapDispatchToProps)(EnhancedTable)));


// WEBPACK FOOTER //
// ./client/src/components/dataTable.js